module.exports = __webpack_public_path__ + "img/live_body.23b9a053.png";